import { graphql } from 'src/graphql';

export const TeamFields = graphql(`
  fragment TeamFields on Teams @_unmask {
    _id
    name
    created
    parent_team
    active_features
    settings {
      billing {
        currency {
          code
          symbol
        }
        tax {
          currency_code
          currency_symbol
          tax_label
          tax_rate
          tax_number_label
        }
        registration
        company_name
        contact_first_name
        contact_last_name
        contact_email
        preferred
        stripe {
          customer_id
        }
        location {
          street1
          level
          city
          state
          postal_code
          country
        }
        subscription {
          end
          credit {
            remaining
          }
        }
        xero_id
      }
      ignore_tracking
      recruitment_page {
        logo
        title
        blurb
      }
    }
    users {
      _id
      added_date
      invited_by
      status
      role
      User {
        _id
        email
        meta {
          identity {
            firstname
            lastname
            middlename
            gender
          }
          social {
            google {
              id
            }
          }
          work {
            title
            company_name
          }
        }
        contact {
          phone {
            country_code
            mobile
          }
        }
      }
    }
  }
`);
